import { _ } from "vue-underscore"
import { mapGetters } from 'vuex'
import { REQUIRED_CURTAIN_PARAMETERS } from "@/constants"
import priceEndpoints from "@/api/prices"
import { tryExceptAwait, hasEqualSize } from "@/utils"

export default {
  computed: {
    ...mapGetters({
      curtainType: 'order/getCurtainType',
      curtainParameters: 'order/getCurtainParameters',
      curtainTemplate: 'order/getCurtainTemplate',
    }),
    requiredCurtainParameters() {
      // make sure to clone the required parameters by slicing to prevent
      // modifying the reference to the same array
      let requiredCurtainParameters =
        (REQUIRED_CURTAIN_PARAMETERS[this.curtainType] || []).slice()
      // check if left_side_of_width is present for split_type unequal pair
      if (
        this.curtainParameters.split_type === 'unequal'
        && !this.curtainParameters.left_side_of_width
      ) {
        requiredCurtainParameters.push('left_side_of_width')
      }
      return requiredCurtainParameters
    },
  },
  methods: {
    addCurtainTemplateParametersFromPrice(data) {
      // some template values need other price data to be calculated,
      // so we only know these after a price calculation (ex. max height);
      // these values are only updated if price/template data are different

      // max height

      if (data.maxheight !== this.curtainTemplate.maxheight) {
        this.$store.commit(
          'order/addCurtainTemplateParameter',
          { 'maxheight': data.maxheight }
        )
      }
      // pleat percentage definition
      if (
        !hasEqualSize(
          data.pleat_percentage_definition,
          this.curtainTemplate.pleat_percentage_definition
        )
      ) {
        this.$store.commit(
          'order/addCurtainTemplateParameter',
          { 'pleat_percentage_definition': data.pleat_percentage_definition }
        )
      }

      // split point definition
      if (
        !hasEqualSize(
          data.split_point_definition,
          this.curtainTemplate.split_point_definition
        )
      ) {
        this.$store.commit(
          'order/addCurtainTemplateParameter',
          { 'split_point_definition': data.split_point_definition }
        )
      }

    },
    async fetchCurtainPriceData() {
      if (!this.requiredCurtainParameters.length) {
        // missing or empty parameters for this curtain type, stop
        return null
      }
      // are there required curtain parameters missing in the flow data?
      const missingCurtainParameters = _.difference(
        this.requiredCurtainParameters,
        Object.keys(this.curtainParameters)
      )

      if (missingCurtainParameters.length > 0) {
        return null
      }

      if (Number(this.curtainParameters.width) < 20
        || Number(this.curtainParameters.height) < 20
      ) {
        // still curtain parameters missing or invalid, stop
        return null
      }
      // now fetch given the curtain type and curtain parameters
      this.$wait.start('isLoadingCurtainPrice')
      const res = await tryExceptAwait(
        priceEndpoints.getProductPrice,
        [
          { articleType: this.curtainType },
          this.curtainParameters
        ]
      )

      if (res.status === 200) {
        // save curtain price to vuex store
        this.$store.commit('order/setCurtainPriceData', res.data)
        this.$store.commit('order/setDropError', '')
      } else {
        if(res.height)
        this.$store.commit('order/setDropError', res.height[0])
        this.$store.commit('order/setCurtainPriceData', {})
      }
      this.$wait.end('isLoadingCurtainPrice')
    }
  }
}
